import { useNumberFormatter } from "react-aria";

type CurrencyWrapperProps = {
  value: number | undefined;
  as?: "p" | "span";
  className?: string;
  showCents?: boolean;
};

export function CurrencyWrapper({
  value,
  as = "p",
  className,
  showCents = false,
}: CurrencyWrapperProps) {
  const formatter = useNumberFormatter({
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  if (value === undefined) {
    const Placeholder = as;
    return <Placeholder className={className}>-</Placeholder>;
  }
  const Element = as;
  const formattedValue = formatter.format(value);
  return (
    <Element className={className}>
      {showCents ? formattedValue : formattedValue.replace(/\.00$/, "")}
    </Element>
  );
}
